const DownloadType = {
  PAGE_DOWNLOAD: 1,
  PRODUCT_DOWNLOAD_IMAGES: 2,
  PRODUCT_DOWNLOAD_DIMENSIONS: 3,
  PRODUCT_DOWNLOAD_FILES: 4,
  PRODUCT_DOWNLOAD_DATASHEET: 5,
} 
export default defineNuxtPlugin((nuxtApp) => {
    const dataAll = useDataAll()
    const siteSettings = useSiteSettingsStore();
    const { $apiMethods, $helpers } = useNuxtApp()


    const downloads = {
      async downloadPage(path, pageCode,asDownload){

        if (downloads.downloadAllowed(false)){
          const urlLoad = $apiMethods.getApiHostUrl() +
          "/api/" +
          $helpers.getLabelId() +
          "/downloadFilePage/" +
          dataAll.getLanguage();
        
          return downloads.handleDownload( 
            urlLoad,
            path,
            { 
              path:downloads.preparePrivatePath(path),
              PageCode:pageCode,
              type:DownloadType.PAGE_DOWNLOAD
            },
            
            asDownload
          );  
        } else {
          if (asDownload){
            alert('todo inloggen');
          }
          return false;
        }
      },
      async downloadArticle(path,articleNumber,asDownload, downloadType, productImages){
        if (downloads.downloadAllowed(productImages)){
          const urlLoad = $apiMethods.getApiHostUrl() +
          "/api/" +
          $helpers.getLabelId() +
          "/downloadFileArticle/" +
          dataAll.getLanguage();

        return downloads.handleDownload( 
            urlLoad,
            path,
            { 
              path:downloads.preparePrivatePath(path),
              articleNumber:articleNumber,
              type:downloadType?downloadType:-1
            },

            asDownload
          )
        } else {
          if (asDownload){
            alert('todo inloggen');
          }
          return false;
        }
      },      
      async handleDownload(urlLoad,path,params,asDownload){
        try {
          const response = await $apiMethods.postApiCall(
            urlLoad,
            params
          )
          if ( !response.ok && !(response instanceof Blob) ) {
            if (asDownload){
              throw new Error(response.message ? response.message : "Unknown error");
            } else {
              return false;
            }
          } else {
            if (asDownload){
               return downloads.createDownload(response,path)
            } else {
              return downloads.createBlob(response)
             }
         }
        } catch (error) {
          alert(error);
        }
      },

      async createDownload(blob,path){
        // const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', path.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
      },
      async createBlob(response){
        return URL.createObjectURL(response)
      },

      downloadAllowed(productImages){
        let ingelogd = true; // todo koppelen aan auth
        if (productImages || ingelogd || !getYesNo(siteSettings, 'DownloadWithCredential')){
          return true;
        }
        return false;
      },
      // if path starts with  /PRIVATE  remove and put a / at the beginning
      preparePrivatePath(path){
        const cleaned = path?.replace(/^\/PRIVATE/, '') || '';
        return cleaned.startsWith('/') ? cleaned : '/' + cleaned;
      }

    }

    nuxtApp.provide('downloads', downloads);
    nuxtApp.provide('downloadType', DownloadType);
});